// Small hand-written primitives (KISS): Tailwind classes, native elements, no component library.

/** Shared look of the text-like form controls (Input, Textarea, Select). */
export const fieldClass =
  "w-full rounded-md border border-zinc-700 bg-zinc-900 px-2.5 py-1.5 text-sm text-zinc-100 placeholder:text-zinc-500 focus:border-emerald-500 focus:outline-none disabled:cursor-not-allowed disabled:border-zinc-800 disabled:bg-zinc-950 disabled:text-zinc-400";
